/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
export { i as initDUIL } from './initDUIL-a7eb8edd.js';
export { B as ButtonTypes, C as ColorVariants, F as FlexDirectionArr, O as Orientation, S as Sizes, a as SizesArr, b as SpacingArr, c as Steps, V as Variants, s as spaceTokenArr } from './constants-c94b83bd.js';
export { D as DHL_ACCORDION } from './constants-deaea6e8.js';
export { D as DHL_ALERT } from './constants-70441acf.js';
export { D as DHL_BACK_TO_TOP } from './constants-e92b5f58.js';
export { D as DHL_BUTTON } from './constants-cb69b9e1.js';
export { D as DHL_BUTTON_GROUP } from './constants-8c7ad339.js';
export { a as DHL_CARD, D as DhlCardSizes } from './constants-bf7d537d.js';
export { D as DHL_CHECKBOX } from './constants-dc6afc21.js';
export { D as DHL_CHECKBOX_GROUP } from './constants-3b50f12f.js';
export { D as DHL_CHIP } from './constants-f81db73a.js';
export { D as DHL_COPY_TEXT } from './constants-73bd9cdb.js';
export { D as DHL_COUNTER } from './constants-df6e09a2.js';
export { u as DHL_DATE_PICKER, D as DaysOfWeek, b as addDays, c as addMonths, d as addYears, m as clamp, g as endOfMonth, h as endOfNextMonth, e as endOfWeek, r as formatDateInTimezone, p as getCalendarNames, o as getNextMonthDate, n as getViewOfMonth, q as getZonedTimeToUtc, t as handleSpaceBarPress, l as inRange, i as isEqual, a as isSameMonthYear, j as setMonth, k as setYear, f as startOfMonth, s as startOfWeek } from './date-utils-4407bb8d.js';
import { D as DHL_FLEX } from './constants-95c3b239.js';
export { D as DHL_FLEX } from './constants-95c3b239.js';
export { D as DHL_GLOBAL_VALIDATION } from './constants-ac0e2540.js';
export { D as DHL_HEADLINE } from './constants-366d7065.js';
export { D as DHL_ICON_WRAPPER } from './constants-74686023.js';
export { D as DHL_ILLUSTRATED_VALIDATION } from './constants-49cd6ac1.js';
export { D as DHL_LABEL } from './constants-529d2569.js';
export { D as DHL_LINK } from './constants-22163418.js';
export { D as DHL_LIST } from './constants-9ad7f0a4.js';
export { D as DHL_LOADER } from './constants-a992b4c7.js';
export { D as DHL_PAGE_HEADLINE } from './constants-69534e48.js';
export { D as DHL_PANEL } from './constants-769b3f92.js';
export { D as DHL_POPOVER } from './constants-6f950472.js';
export { D as DHL_PROGRESS_INDICATOR } from './constants-1537c594.js';
export { D as DHL_RADIO_BUTTON } from './constants-0d5ab80c.js';
export { D as DHL_RADIO_BUTTON_GROUP } from './constants-e7274996.js';
import { D as DHL_TEXT } from './constants-b27a9bbb.js';
export { D as DHL_TEXT } from './constants-b27a9bbb.js';
export { D as DHL_SELECTABLE_CARD } from './constants-1f21f58b.js';
export { b as DHL_SLIDER, c as DHL_SLIDER_HORIZONTAL_VARIANT_HEIGHT, d as DHL_SLIDER_VERTICAL_VARIANT_HEIGHT, a as DhlSliderThumbPositionKey, D as DhlSliderVariant } from './constants-6bf85e64.js';
export { D as DHL_STAGE } from './constants-776886e7.js';
export { D as DHL_STAGE_TILES } from './constants-fc728849.js';
export { D as DHL_SWITCH } from './constants-79491391.js';
export { D as DHL_TABLE } from './constants-1589b848.js';
export { D as DHL_TABS } from './constants-362d9140.js';
import './constants-35b5fb29.js';

const DHL_READ_MORE = {
    WEIGHT: DHL_TEXT.WEIGHT,
    FONT_STYLE: DHL_TEXT.FONT_STYLE,
    STRETCH: DHL_TEXT.STRETCH,
    SIZE: DHL_TEXT.SIZE,
};

const DHL_STACK = {
    WRAP: DHL_FLEX.WRAP,
    DIRECTION: DHL_FLEX.DIRECTION,
};

export { DHL_READ_MORE, DHL_STACK };

//# sourceMappingURL=index.js.map